import React, { useState } from "react";
import { Upload, X, Send, AlertCircle } from "lucide-react";
import { createGrievanceApi } from "../../../app/api";
import toast from "react-hot-toast";
import { convertImageToWebP } from "../../../utils/convertImageToWebP";

const GrievanceForm = ({ onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 10 * 1024 * 1024) {
        toast.error("File size should be less than 10MB");
        return;
      }
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.description) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);
    const data = new FormData();
    data.append("title", formData.title);
    data.append("description", formData.description);
    if (file) data.append("attachment", await convertImageToWebP(file));

    try {
      await createGrievanceApi(data);
      toast.success("Grievance submitted successfully");
      onSuccess();
    } catch (err) {
      toast.error(err.message || "Failed to submit grievance");
    } finally {
      setLoading(false);
    }
  };

  // return (
  //   <div className="bg-slate-900/80 border border-slate-800 rounded-2xl p-6 backdrop-blur-md">
  //     <div className="flex items-center gap-3 mb-6">
  //       <div className="p-3 rounded-2xl bg-indigo-500/10 text-indigo-400">
  //         <AlertCircle size={24} />
  //       </div>
  //       <div>
  //         <h2 className="text-xl font-bold text-white">Raise a Grievance</h2>
  //         <p className="text-slate-400 text-sm">Describe your issue clearly for faster resolution.</p>
  //       </div>
  //     </div>

  //     <form onSubmit={handleSubmit} className="space-y-5">
  //       <div>
  //         <label className="block text-slate-300 text-sm font-semibold mb-2">Title</label>
  //         <input
  //           type="text"
  //           required
  //           className="w-full bg-slate-950/50 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-indigo-500 transition-colors"
  //           placeholder="E.g., Office equipment issue, Salary discrepancy"
  //           value={formData.title}
  //           onChange={(e) => setFormData({ ...formData, title: e.target.value })}
  //         />
  //       </div>

  //       <div>
  //         <label className="block text-slate-300 text-sm font-semibold mb-2">Description</label>
  //         <textarea
  //           required
  //           rows={4}
  //           className="w-full bg-slate-950/50 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-indigo-500 transition-colors resize-none"
  //           placeholder="Provide as much detail as possible..."
  //           value={formData.description}
  //           onChange={(e) => setFormData({ ...formData, description: e.target.value })}
  //         />
  //       </div>

  //       <div>
  //         <label className="block text-slate-300 text-sm font-semibold mb-2">Attachment (Optional)</label>
  //         {preview ? (
  //           <div className="relative rounded-xl overflow-hidden border border-slate-800 group">
  //             <img src={preview} alt="Preview" className="w-full h-48 object-cover" />
  //             <button
  //               type="button"
  //               onClick={() => { setFile(null); setPreview(null); }}
  //               className="absolute top-2 right-2 p-1 bg-rose-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
  //             >
  //               <X size={16} />
  //             </button>
  //           </div>
  //         ) : (
  //           <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-slate-800 rounded-xl cursor-pointer hover:border-indigo-500/50 hover:bg-slate-950/30 transition-all">
  //             <div className="flex flex-col items-center justify-center pt-5 pb-6">
  //               <Upload className="text-slate-500 mb-2" size={24} />
  //               <p className="text-xs text-slate-500">Click to upload or drag and drop</p>
  //               <p className="text-[10px] text-slate-600 mt-1">PNG, JPG or WEBP (MAX. 10MB)</p>
  //             </div>
  //             <input type="file" className="hidden" accept="image/*" onChange={handleFileChange} />
  //           </label>
  //         )}
  //       </div>

  //       <div className="flex gap-3 pt-4">
  //         <button
  //           type="button"
  //           onClick={onCancel}
  //           className="flex-1 bg-slate-800 hover:bg-slate-700 text-white font-bold py-3 rounded-xl transition-colors"
  //         >
  //           Cancel
  //         </button>
  //         <button
  //           type="submit"
  //           disabled={loading}
  //           className="flex-1 bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white font-bold py-3 rounded-xl transition-all flex items-center justify-center gap-2"
  //         >
  //           {loading ? (
  //             <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
  //           ) : (
  //             <>
  //               <Send size={18} />
  //               Submit
  //             </>
  //           )}
  //         </button>
  //       </div>
  //     </form>
  //   </div>
  // );



  return (
    <div className="max-w-3xl mx-auto mt-10">
      
      <div className="relative overflow-hidden rounded-[32px] p-6 md:p-8 bg-gradient-to-br from-[#1e174a] to-[#0f0c29] text-white border border-white/10 shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]">
  
        {/* 🔥 Glow Effects (same as admin) */}
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 blur-[100px]" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/20 blur-[100px]" />
  
        <div className="relative z-10">
  
          {/* HEADER */}
          <div className="flex items-center gap-4 mb-8">
            <div className="p-3 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600">
              <AlertCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold">Raise a Grievance</h1>
              <p className="text-white/60 text-sm">
                Describe your issue clearly for faster resolution
              </p>
            </div>
          </div>
  
          {/* FORM */}
          <form onSubmit={handleSubmit} className="space-y-6">
  
            {/* TITLE */}
            <div>
              <label className="block text-sm font-semibold text-white/80 mb-2">
                Title
              </label>
              <input
                type="text"
                required
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-indigo-500 outline-none"
                placeholder="E.g., Salary issue, Laptop problem"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </div>
  
            {/* DESCRIPTION */}
            <div>
              <label className="block text-sm font-semibold text-white/80 mb-2">
                Description
              </label>
              <textarea
                required
                rows={4}
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-indigo-500 outline-none resize-none"
                placeholder="Explain your issue in detail..."
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </div>
  
            {/* FILE UPLOAD */}
            <div>
              <label className="block text-sm font-semibold text-white/80 mb-2">
                Attachment (Optional)
              </label>
  
              {preview ? (
                <div className="relative rounded-xl overflow-hidden border border-white/10 group">
                  <img src={preview} className="w-full h-48 object-cover" />
                  <button
                    type="button"
                    onClick={() => { setFile(null); setPreview(null); }}
                    className="absolute top-2 right-2 p-1 bg-rose-500 text-white rounded-full opacity-0 group-hover:opacity-100"
                  >
                    <X size={16} />
                  </button>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-white/10 rounded-xl cursor-pointer hover:border-indigo-500/50 hover:bg-white/5 transition">
                  <Upload className="text-white/40 mb-2" size={24} />
                  <p className="text-xs text-white/50">Click to upload</p>
                  <input type="file" className="hidden" accept="image/*" onChange={handleFileChange} />
                </label>
              )}
            </div>
  
            {/* BUTTONS */}
            <div className="flex gap-3 pt-4">
  
              <button
                type="button"
                onClick={onCancel}
                className="flex-1 py-3 rounded-xl text-sm font-semibold bg-white/10 border border-white/20 hover:bg-white/20 transition"
              >
                Cancel
              </button>
  
              <button
                type="submit"
                disabled={loading}
                className="flex-1 py-3 rounded-xl text-sm font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  <>
                    <Send size={16} />
                    Submit
                  </>
                )}
              </button>
  
            </div>
  
          </form>
        </div>
      </div>
    </div>
  );
};

export default GrievanceForm;
